import React from "react";

export const Surveillance: React.FC = () => {
  return (
    <div className="p-8">
      <div className="flex flex-col items-center justify-center bg-yellow-100 border-2 border-yellow-400 p-6 rounded-lg shadow-md">
        <svg
          className="w-12 h-12 text-yellow-500 mb-4"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
          />
        </svg>
        <h3 className="text-xl font-semibold mb-2 text-yellow-800">
          Under Construction
        </h3>
        <p className="text-md text-yellow-700 text-center">
          This section is being built.
        </p>
      </div>
    </div>
  );
};
